export default "__VITE_ASSET__128c7f76__"